// assets/ga4-datalayer-bridge.js
(function () {
  // GA4: niente spazi nel nome evento
  function normalizeEventName(name) {
    return String(name || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "_"); // "quiz btn" -> "quiz_btn"
  }

  function sendToGA4(obj) {
    if (!obj || typeof obj !== "object") return;

    // Intercetta SOLO il tuo evento
    if (obj.event !== "quiz btn") return;

    if (typeof window.gtag !== "function") {
      if (window.location.search.includes("debug_banner=1")) {
        console.warn("[ga4-bridge] gtag non trovato: GA4 non è caricato in pagina");
      }
      return;
    }

    const gaEventName = normalizeEventName(obj.event);

    const params = {
      banner_text: obj.banner_text || "",
      link_url: obj.link_url || "",
      page_path: obj.page_path || window.location.pathname,
      page_location: obj.page_location || window.location.href
    };

    window.gtag("event", gaEventName, params);

    if (window.location.search.includes("debug_banner=1")) {
      console.log("[ga4-bridge] sent to GA4:", gaEventName, params);
    }
  }

  // dataLayer sempre presente
  window.dataLayer = window.dataLayer || [];

  // Processa eventuali push già avvenuti prima del bridge
  try {
    for (var i = 0; i < window.dataLayer.length; i++) {
      sendToGA4(window.dataLayer[i]);
    }
  } catch (e) {}

  // Wrappa push per intercettare i prossimi eventi
  var originalPush = window.dataLayer.push.bind(window.dataLayer);
  window.dataLayer.push = function () {
    for (var i = 0; i < arguments.length; i++) {
      sendToGA4(arguments[i]);
    }
    return originalPush.apply(null, arguments);
  };
})();
